export default "https://cdn-static.gokick.com/assets/0f3104c02f0c7e58561d070a1e1ba5e916429e4c/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";